
export type CancelSubscriptionBody = {
  /** 취소 사유 */
  reason?: string;
};
